<template>
  <div class="home">
    <div :class="['home-banner', {'placeholder-padding': !sliderList.length}]">
      <swiper v-if="sliderList.length">
        <swiper-slider v-for="(item, idx) in sliderList" :key="idx">
          <div class="banner-item">
            <!-- <div class="banner-item-logo logo-money"></div> -->
            <img-v3 :src="item.icon_url" alt="" class="banner-item-logo" />
            <div class="banner-item-title">
              {{ item.title || $t(`home.title${idx+1}`) }}
            </div>
            <div class="banner-item-subTitle">
              {{ item.sub_title || $t(`home.desc${idx+1}`) }}
            </div>
          </div>
        </swiper-slider>
        <!-- <swiper-slider>
          <div class="banner-item">
            <div
              class="banner-item-logo logo-security"
              :class="{ 'logo-call': location_country === 'RU' }"
            ></div>
            <div class="banner-item-title">
              {{ custom_text.t3 || $t("home.title2") }}
            </div>
            <div class="banner-item-subTitle">
              {{ custom_text.t4 || $t("home.desc2") }}
            </div>
          </div>
        </swiper-slider>
        <swiper-slider>
          <div class="banner-item">
            <div
              class="banner-item-logo logo-card"
              :class="{ 'logo-didi': location_country === 'RU' }"
            ></div>
            <div class="banner-item-title">
              {{ custom_text.t5 || $t("home.title3") }}
            </div>
            <div class="banner-item-subTitle">
              {{ custom_text.t6 || $t("home.desc3") }}
            </div>
          </div>
        </swiper-slider> -->
      </swiper>
    </div>
    <div v-if="has_reward_banner && banner_config" class="guarantee-banner">
      <img-txt-link :form-item="banner_config" v-if="banner_config.type === 'img-txt-link'"></img-txt-link>
    </div>
    <div class="phone-wrapper">
      <div class="code" @click="phoneFocus">{{ phoneCountryCode }}</div>
      <div class="input">
        <input
          ref="phone_input"
          autocomplete="off"
          type="tel"
          v-model="phoneNum"
          :placeholder="$t('home.phonePlaceholder')"
          @keyup="handleKeyUp"
          @click="(location_country === 'RU' || location_country === 'UA') && login()"
        />
      </div>
    </div>
    <div class="agree-list-wrapper" v-if="location_country !== 'RU' || location_country !== 'UA'">
      <div class="agree-wrapper" v-for="(item, idx) in agreeList" :key="idx">
        <i @click="handleClick('agree',item)" :class="[{ active: item.is_agree === null ? item.default_select : item.is_agree }]"></i>
        <span @click="handleClick('agree',item)">{{ $t("home.agree0") }}</span>
        <span @click="handleClick('rule', item)" class="active">{{
          item.title || $t("home.agree1")
        }}</span>
      </div>
    </div>
    <div class="btn-wrapper">
      <a
        :class="{ active: isCanSubmit || location_country === 'RU' || location_country === 'UA' }"
        @click="login"
        >{{ btnTxt }}</a
      >
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlider } from "../components/base/Swiper";
import { mapMutations, mapState } from "vuex";

import { post, get } from "../tools/request";
import { fireBase ,openWebview} from "../tools/utils";
// import { SUPPORT_COUNTRY_CONFIG } from "../tools/constant";
import { showDialog, showAlertDialog, showLoadingToast } from "../tools/Tip";
import ImgTxtLink from "../components/base/img-txt-link.vue";

import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../tools/constant";
const REG_PHONE_NUM = /^\d+$/;
export default {
  data() {
    return {
      phoneNum: "",
      isAgree: false,
      phoneNumValidate: false,
      configData: {},
      agreeList: [],
      has_reward_banner: false,
      banner_config: {}
    };
  },
  computed: {
    ...mapState(["_ticket", "_login_btn_text", "_phone_focus_global"]),
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    phoneCountryCode() {
      return (
        LOGIN_CONFIG[this.location_country] ||
        window.didii18nconfig[this.location_country] || {}
      ).country_calling_code;
    },
    btnTxt() {
      if (this._login_btn_text) {
        return this.$t("GDriver_button_Join_pQYr");
      }
      return ends.isFleet
        ? this.$t("login_btn_fleet")
        : this.$t("login_btn_global");
    },
    isCanSubmit() {
      let isAgree = this.agreeList.every(item => item.is_agree === null ? !!item.default_select : !!item.is_agree);
      return isAgree && this.phoneNumValidate;
    },
    custom_text() {
      let o = {
        ZA: {
          t1: this.$t("GDriver_homepage_Lower_service_SVYA"),
          t2: this.$t("GDriver_homepage_We_will_WQWN"),
          t3: this.$t("GDriver_homepage_Safety_anytime_cYRg"),
          t4: this.$t("GDriver_homepage_DiDi_pays_XmAz"),
          t5: this.$t("GDriver_homepage_Get_additional_YUiT"),
          t6: this.$t("GDriver_homepage_DiDi_offers_jJhp"),
        },
      };
      return o[this.location_country] || {};
    },
    sliderList() {
      return this.configData.carousel_box || [];
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    phoneFocus() {
      this._phone_focus_global && this.$refs.phone_input.focus();
    },
    handleKeyUp() {
      this.validatePhoneNum();
    },
    validatePhoneNum() {
      this.phoneNumValidate = REG_PHONE_NUM.test(this.phoneNum);
    },
    login() {
      // @20210114 俄罗斯防攻击改用sdk乱序键盘
      if (!this.isCanSubmit && (this.location_country !== "RU" || this.location_country !== "UA")) {
        gtm({
          event: "s1PassportRegister",
          PhoneNumber: "blank",
          Country: this.location_country,
          error: "true",
        });
        return;
      }
      try {
        Omega.trackEvent("tone_p_x_login_confm_newuser_ck");
        //点击失焦，解决RU input点击问题
        this.$refs.phone_input.blur()
        gtm({
          event: "s1PassportRegister",
          PhoneNumber: "valid",
          Country: this.location_country,
          error: "false",
        });
      } catch (e) {}

      const loginAction = (callback, fallback) => {
        if (this.location_country === "RU" || this.location_country === "UA") {
          return login.login(callback, fallback);
        }
        return login.checkPhone(this.phoneNum, callback, fallback);
      };

      showLoadingToast(this, this.$t("加载中"), 500);

      loginAction(
        (response) => {
          const { ticket, cell, uid } = response;
          this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });

          if (this.params.get("helpDriverReg") == 1) {
            //fleet 端 车头帮司机注册并绑定的逻辑
            this.handleFleet();
          } else {
            this.$router.replace({ name: "home" });
          }
          fireBase("tone_p_x_login_success_sw");
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleFleet() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      up.set("ticket", this._ticket);
      get(process.env.DRIVER_CHECK, {
        params: up,
      })
        .then((data) => {
          //  已注册能绑定 => bindTips
          this.$router.replace({
            name: `bindTip${sc[this.location_country] || "Mx"}`,
            params: {
              driverInfo: data.driver_info,
            },
          });
        })
        .catch((e) => {
          //  未注册 => 跳转到注册页,20002
          const { errmsg, errno } = e;
          if (+errno === 20002) {
            this.$router.replace({ name: "home" });
          } else {
            //  已注册不能绑定 => 错误提示,错误码不等于0且不等于20002
            showAlertDialog(this, errmsg);
            login.logout(
              () => console.log("logout success"),
              (e) => console.log(e)
            );
          }
        })
        .finally((x) => this.toast.hide());
    },

    handleClick(type, config) {
      switch (type) {
        case "agree":
          // this.isAgree = !this.isAgree;
          config.is_agree = config.is_agree === null ? !config.default_select : !config.is_agree;
          if (config.is_agree) {
            try {
              Omega.trackEvent("tone_p_x_login_law_ck");
            } catch (e) {}
          }
          break;
        case "rule":
          // let lang = SUPPORT_COUNTRY_CONFIG[this.location_country]["lang"];
          let lang = this.params.get("lang");
          let url = config.terms_conditions_url || `https://common.didiglobal.com/common/v6/driver/law?location_country=${this.location_country}&lang=${lang}`;
          openWebview(url)
          // window.location.href = url;
        default:
          break;
      }
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("page_name", "home_page");
      post(process.env.LOGIN_INFO, up)
        .then(data => {
          this.configData = data || {};
          this.agreeList = (this.configData.privacy_policy || []).map(item => { return {...item, is_agree: null} });
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    },
    getRewardConf() {
      showLoadingToast(this)
      let up = new URLSearchParams(location.search);

      post(process.env.LOGIN_BANNER_INFO, up)
        .then((res) => {
          console.log(res)
          this.has_reward_banner = res.is_show_banner;
          if (res.is_show_banner && res.passport_reward_banner) {
            let passport_reward_banner = { ...res.passport_reward_banner };
            let reward_conf = { ...res.reward_conf }
            let text = passport_reward_banner.title || '';
            let rides_reward = (reward_conf.rides_reward || []).pop() || {};
            passport_reward_banner.title = reward_conf.areaId ?
                                          text.replace(/\{\{city\}\}/, reward_conf.areaName || '').replace(/\{\{fee_amount\}\}/, rides_reward.reward || '')
                                          : '';
            this.banner_config = passport_reward_banner;
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.toast.hide()
        });;
    }
  },
  mounted() {
    setTimeout(this.getPageConfig, 0);
    Omega.trackEvent("tone_p_x_account_loginnew_sw", "", {
      client_user_agent: navigator.userAgent, // 必须
      // client_ip_address: '', // 可选
      fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
      fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
    });

    // @210705 login保底奖实验下期
    // 20210910 MX login保底奖实验上线
    this.getRewardConf();

    // this.setState({
    //   _help_icon: true
    // });
  },
  components: {
    Swiper,
    SwiperSlider,
    ImgTxtLink
  },
};
</script>
<style  lang="scss" scoped>
@import "../css/var.scss";
@import "../css/mixin.scss";
.home {
  width: 100%;
  min-height: 100%;
  background: #fff;
  position: relative;
  font-size: 0.36rem;
  touch-action: none;
  .home-banner {
    background-image: linear-gradient(-135deg, #fe7947 0%, #ffb984 100%);
    margin-bottom: 0.8rem;
    &.placeholder-padding {
      padding-top: 60%;
    }
    .banner-item {
      padding: 0.64rem;
      text-align: center;
      color: #fff;
      .banner-item-logo {
        margin: 0 auto 0.48rem;
        max-width: 0.82rem;
        max-height: 0.82rem;
        &.logo-car {
          width: 0.942rem;
          height: 0.546rem;
          background-size: 0.942rem 0.546rem;
          @include bg-img("home-logo-car", "../images/");
        }
        &.logo-card {
          width: 0.81rem;
          height: 0.546rem;
          background-size: 0.81rem 0.546rem;
          @include bg-img("home-logo-card", "../images/");
        }
        &.logo-money {
          width: 0.82rem;
          height: 0.742rem;
          background-size: 0.82rem 0.742rem;
          @include bg-img("home-logo-money", "../images/");
        }
        &.logo-security {
          width: 0.772rem;
          height: 0.893rem;
          background-size: 0.772rem 0.893rem;
          @include bg-img("home-logo-security", "../images/");
        }
        &.logo-call {
          width: 0.82rem;
          height: 0.742rem;
          background-size: 0.82rem 0.742rem;
          @include bg-img("customer_service", "../images/");
        }
        &.logo-didi {
          width: 0.82rem;
          height: 0.742rem;
          background-size: 0.82rem 0.742rem;
          @include bg-img("didi_logo", "../images/");
        }
      }
      .banner-item-title {
        font-size: 0.44rem;
        font-weight: 700;
        margin-bottom: 0.48rem;
      }
      .banner-item-subTitle {
        font-size: 0.32rem;
        margin-bottom: 0.48rem;
        line-height: 1.2;
      }
    }
  }
  .guarantee-banner {
    width: 100%;
    padding: 0 0.36rem;
    box-sizing: border-box;
    .img-container {
      margin-top: 0;
      ::v-deep .img-text {
        width: 100%;
        padding: 0 0.24rem 0 0.8rem;
        box-sizing: border-box;
        color: #18C47C;
        font-size: 0.22rem;
        font-weight: 700;
        line-height: 0.25rem;
      }
    }
  }
  .phone-wrapper {
    padding: 0.34rem 0.4rem;
    display: flex;
    margin-bottom: 0.8rem;
    @include border-1px(bottom);
    @include border-1px(top);
    .code {
      padding: 0.2rem;
      @include border-1px(right);
    }
    .input {
      flex: 1;
      padding-left: 0.34rem;
      input {
        font-size: 0.4rem;
        display: block;
        width: 100%;
        height: 100%;
        background: transparent;
      }
    }
  }
  .agree-list-wrapper {
    padding: 0 0.4rem;
    margin-bottom: 0.8rem;
    .agree-wrapper {
      > i {
        display: inline-block;
        vertical-align: middle;
        width: 0.36rem;
        height: 0.36rem;
        background-size: 0.36rem;
        @include bg-img("icon-unchecked", "../images/");
        &.active {
          @include bg-img("icon-checked", "../images/");
        }
      }
      > span {
        display: inline-block;
        vertical-align: middle;
        color: #999;
        font-size: 0.28rem;
        &.active {
          color: $main-orange;
        }
      }
    }
  }
  .btn-wrapper {
    padding: 0 0.4rem;
    > a {
      display: block;
      border-radius: 0.12rem;
      padding: 0.33rem 0;
      text-align: center;
      color: #999;
      background: $main-bg-color;
      &.active {
        color: #fff;
        background: $main-orange;
      }
    }
  }
}
</style>

